export default __webpack_public_path__ + "static/media/barracuda-ltd-1200-275.221e09e0.png";